import { FilePdfBoxIcon } from './FilePdfBoxIcon';

/**
 * author: Simran
 * id C09B20B5-3650-4F36-AC40-540ACE36EB6E
 * name file-pdf-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-pdf-box.svg
 * tags
 * - Files / Folders 
 */
export const AdobeAcrobatIcon = FilePdfBoxIcon;
export default AdobeAcrobatIcon